var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "tag-group tags"
  }, _vm._l(_vm.currentTagData, function (tag, index) {
    return _c("a-checkable-tag", {
      key: index,
      attrs: {
        checked: tag.checked
      },
      on: {
        change: checked => _vm.selectTagChange(index, tag, checked)
      }
    }, [_vm._v(" " + _vm._s(tag.fieldFrontValue) + " ")]);
  }), 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };